const uri = "/Profile";

export default uri;
